export default {
  title1: {
    en: 'READY TO UN-PAUSE?',
  },
  title2: {
    en: 'BACK AGAIN?',
  },

  text1: {
    en: `
      We hope so! 
      You can even change your subscription frequency to keep discovering new scents every 2 or 3 months.
    `,
  },

  text2: {
    en: `
      Glad to see that you’re still exploring your options! 
      Remember, you can always come back on an every 2 or 3 months subscription if you’d like to receive fewer scents.
    `,
  },

  buttonUnpause: {
    en: 'Unpause me',
  },
  buttonUnpauseAndChangeFreq: {
    en: 'Unpause & change frequency',
  },

  buttonSkip1: {
    en: 'Not yet',
  },
  buttonSkip2: {
    en: 'No Thanks',
  },

  reactivateSubscription: {
    en: 'UNPAUSE MY SUBSCRIPTION',
  },
}
